module.exports = __webpack_public_path__ + "img/commodityunchecked.1d8c70e5.svg";